// shared/loading-state/loading-state.component.ts
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-state',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col items-center justify-center py-16">
      <i class="pi pi-spin pi-spinner text-4xl text-primary-500 mb-4"></i>
      <p class="text-surface-600 dark:text-surface-400">{{ message }}</p>
      @if (subMessage) {
        <p class="text-sm text-surface-400 dark:text-surface-500 mt-1">{{ subMessage }}</p>
      }
    </div>
  `
})
export class LoadingStateComponent {
  @Input() message: string = 'Loading...';
  @Input() subMessage?: string;
}